export const theme = {
  colors: {
    primaryBlue: "#0056D2",
    hoverBlue: "#0041AD",
    accentBlue: "#2A73CC",
    navyText: "#0B1A3C",
    background: "#F4F6FA",
    cardBg: "#FFFFFF",
    lines: "#E6EDF2",
    success: "#008060",
    danger: "#C0362C",
    white: "#FFFFFF",
  },
  fonts: {
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  spacing: {
    pagePad: "2rem",
    cardPad: "1.5rem",
  },
};
